import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Confirm ARCHIVING a Team Direction shared priority (mobile-polish pass).
 * Archive is REVERSIBLE (unarchive later) and Team Direction has NO hard
 * delete, so this is a NEUTRAL confirmation — never destructive-red (red is
 * reserved for true delete, which does not exist here).
 *
 * LINK-AGNOSTIC BY CONSTRUCTION: the dialog receives NOTHING about the target's
 * private links or relevance state — only that an archive was requested. The
 * copy and styling are a FIXED literal, byte-identical whether the priority has
 * no linked personal work, the current user's linked work, or any relevance
 * mark. It must never say "this has linked work" / "your work will remain" /
 * anything conditional on private state (no link/relevance oracle).
 */
export interface TeamPriorityArchiveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isAr: boolean;
  busy?: boolean;
  onConfirm: () => void;
}

export function TeamPriorityArchiveDialog({
  open,
  onOpenChange,
  isAr,
  busy,
  onConfirm,
}: TeamPriorityArchiveDialogProps) {
  const t = (en: string, ar: string) => (isAr ? ar : en);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="team-priority-archive">
        <DialogHeader>
          <DialogTitle>
            {t("Archive this team priority?", "أرشفة أولوية الفريق هذه؟")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "This moves it out of active Team Direction. You can unarchive it later.",
              "هذا ينقلها خارج توجيه الفريق النشط. يمكنك إلغاء أرشفتها لاحقًا.",
            )}
          </DialogDescription>
        </DialogHeader>
        {/* Clear breathing room between the body text and the action; the
            confirm is NEUTRAL (secondary), never destructive-red. */}
        <DialogFooter className="mt-4" data-testid="td-archive-footer">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            data-testid="td-archive-cancel"
          >
            {t("Cancel", "إلغاء")}
          </Button>
          <Button
            variant="secondary"
            disabled={busy}
            onClick={onConfirm}
            data-testid="td-archive-confirm"
          >
            {t("Archive", "أرشفة")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
